import React from "react";
import EmailIcon from "@mui/icons-material/Email";

function GddEmailIcon({ iconColor, iconSize = "small", ...other }) {
    return <EmailIcon color={iconColor} fontSize={iconSize} {...other} />;
}

export default GddEmailIcon;
